export default "__VITE_ASSET__DFOqpx2D__"